import type { Bus } from "./lib/Bus"
import { PollCRDT, phenom } from "./poll"
import { ResultsView } from "./ResultsView"
import { SplashGrid } from "./SplashGrid"

export function ResultsController(props: {
  pollBus: Bus<PollCRDT>
}): JSX.Element {
  const { pollBus } = props
  return (
    <SplashGrid>
      <ResultsView poll={phenom({ ...pollBus.state.get(), id: pollBus.id })} />
    </SplashGrid>
  )
}
